import AudioIconSvg from "../../../../../components/SVG/AudioIconSvg";
import DocumentIconSvg from "../../../../../components/SVG/DocumentIconSvg";
import PhotoIconSvg from "../../../../../components/SVG/PhotoIconSvg";
import VideoIconSvg from "../../../../../components/SVG/VideoIconSvg";
import { getViewDocumentUrl } from "../../../../../utils/docUtils";
// import { getViewDocumentUrl } from "../../../../../utils/docUtils";
import { getViewTaskDocumentUrl } from "../../../../../utils/taskUtils";
import CommentBox from "../../../components/CommentBox/CommentBox";
import Header from "../../../components/SubtaskHeader/SubtaskHeader";
import { useMediaViewer } from "../../../../../components/MediaViewerModal/useMediaViewer";
import './SubtaskScreens.css';

const DocumentSubtask = ({ subtask }) => {
  const { openMedia, MediaViewer } = useMediaViewer();
  console.log({ subtask });

  let actualAndExpectedData = subtask?.actual_and_expected_data;



  return (
    <div className={`subtask-card status-${subtask?.status?.status_code?.toLowerCase()}`}>
      <Header subtask={subtask} />

      <div className="document-compare">
        {
          // actualAndExpectedData?.previous_value?.length > 0  && 
          actualAndExpectedData?.previous_value?.length > 0 &&
          actualAndExpectedData?.previous_value?.some(v => v != null) && 
            <div className="original">
              <label>Previous Documents</label>
              {/* ------------------ PREVIOUS VALUE ----------------------- */}
              <div className="file-grid">
                {
                  // subtask?.task_documents?.map(doc => (
                  actualAndExpectedData?.previous_value?.map(doc => (
                    <div 
                      key={doc?.category_id} 
                      className="file-card"
                      onClick={async () => {
                        // let document = await getViewTaskDocumentUrl(doc);
                        let document = await getViewDocumentUrl(doc);

                        openMedia(document?.document_url, subtask?.task_type?.type_code === 'AUDIO' ? 'audio' : subtask?.task_type?.type_code === 'VIDEO' ? 'video' : subtask?.task_type?.type_code === 'PHOTO' ? 'image' : 'document');
                      }}
                    >
                      {/* <span className="icon pdf" /> */}
                      {
                        subtask?.task_type?.type_code === 'DOCUMENT' &&
                        <DocumentIconSvg fillColor={"var(--icon-color)"} size={42} />
                      }
                      {
                        subtask?.task_type?.type_code === 'AUDIO' &&
                        <AudioIconSvg fillColor={"var(--icon-color)"} size={42} />
                      }
                      {
                        subtask?.task_type?.type_code === 'VIDEO' &&
                        <VideoIconSvg fillColor={"var(--icon-color)"} size={42} />
                      }
                      {
                        subtask?.task_type?.type_code === 'PHOTO' &&
                        <PhotoIconSvg fillColor={"var(--icon-color)"} size={42} />
                      }
                      <p>{doc?.document_file_name}</p>
                      <small>{doc?.file_size}</small>
                      <div className={`document-tag ${ 
                        subtask?.task_type?.type_code === 'DOCUMENT' ? 'doc' : 
                        subtask?.task_type?.type_code === 'AUDIO' ? 'audio' : 
                        subtask?.task_type?.type_code === 'VIDEO' ? 'video' : ''
                      }`}>
                        {doc?.document_file_name?.split('.')?.[1]?.toUpperCase()}
                      </div>
                    </div>
                  ))
                }
              </div>
          </div>
        }


        {/* ------------------ UPDATED VALUE ----------------------- */}
        {
          actualAndExpectedData?.updated_value?.length > 0 && 
          <div className="corrected">
            <label>Updated Documents</label>
            <div className="file-grid">
              {
                // subtask?.task_documents?.map(doc => (
                actualAndExpectedData?.updated_value?.map(doc => (
                  <div 
                    key={doc?.category_id} 
                    className="file-card"
                    onClick={async () => {
                      let document = await getViewTaskDocumentUrl(doc);

                      openMedia(document?.document_url, subtask?.task_type?.type_code === 'AUDIO' ? 'audio' : subtask?.task_type?.type_code === 'VIDEO' ? 'video' : subtask?.task_type?.type_code === 'PHOTO' ? 'image' : 'document');
                    }}
                  >
                    {/* <span className="icon pdf" /> */}
                    {
                      subtask?.task_type?.type_code === 'DOCUMENT' &&
                      <DocumentIconSvg fillColor={"var(--icon-color)"} size={42} />
                    }
                    {
                      subtask?.task_type?.type_code === 'AUDIO' &&
                      <AudioIconSvg fillColor={"var(--icon-color)"} size={42} />
                    }
                    {
                      subtask?.task_type?.type_code === 'VIDEO' &&
                      <VideoIconSvg fillColor={"var(--icon-color)"} size={42} />
                    }
                    {
                      subtask?.task_type?.type_code === 'PHOTO' &&
                      <PhotoIconSvg fillColor={"var(--icon-color)"} size={42} />
                    }
                    <p>{doc?.document_file_name}</p>
                    <small>{doc?.file_size}</small>
                    <div className={`document-tag ${ 
                      subtask?.task_type?.type_code === 'DOCUMENT' ? 'doc' : 
                      subtask?.task_type?.type_code === 'AUDIO' ? 'audio' : 
                      subtask?.task_type?.type_code === 'VIDEO' ? 'video' : ''
                    }`}>
                      {doc?.document_file_name?.split('.')?.[1]?.toUpperCase()}
                    </div>
                  </div>
                ))
              }
            </div>
            {
              (actualAndExpectedData?.field_name === "six_month_bm_bank_statement" || 
              actualAndExpectedData?.field_name === "bank_statement") &&
              <span>Password: <strong>{actualAndExpectedData?.updated_value?.[0]?.doc_password || "N/A"}</strong></span>
            }
          </div>
        }
      </div>

      <CommentBox subtask={subtask} />
      {MediaViewer}
    </div>
  );
}

export default DocumentSubtask;
